import { render, staticRenderFns } from "./GlobalSearchResultApplication.vue?vue&type=template&id=a27fa236&scoped=true"
import script from "./GlobalSearchResultApplication.vue?vue&type=script&lang=js"
export * from "./GlobalSearchResultApplication.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchResultApplication.vue?vue&type=style&index=0&id=a27fa236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27fa236",
  null
  
)

export default component.exports